import { render } from "./view_menu.vue?vue&type=template&id=1df3cf1a&scoped=true"
import script from "./view_menu.vue?vue&type=script&lang=js"
export * from "./view_menu.vue?vue&type=script&lang=js"

import "./view_menu.vue?vue&type=style&index=0&id=1df3cf1a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df3cf1a"]])

export default __exports__